import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { HubService } from 'app/hub.service';
import { ApiService } from 'app/api.service';

@Injectable()
export class RoleCanActivateRouteGuard implements CanActivate {
  private Parse: any = require('parse');
  private roles: any[] = [];

  constructor(private router: Router, private hubService: HubService, private apiService: ApiService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    const allowedRoles = route.data.allowedRoles;
    // console.log("allowedRoles: " + JSON.stringify(allowedRoles));

    if (!this.Parse.User.current()) {
      this.router.navigate(['login']);
      return false;
    } else {
      // build query
      const where = {
        "users": {
          "__type": "Pointer",
          "className": "_User",
          "objectId": this.apiService.Parse.User.current().id
        }
      };
      // get user roles
      this.hubService.getResource('_Role', where, null, null, null, null)
        .subscribe(
        response => {
          // console.log("role response for user " +this.apiService.Parse.User.current().id+ " :" + JSON.stringify(response));
          for (let i = 0; i < response.length; i++) {
            // console.log("user role: " + response[i].objectId);
              // this.roles.push(response[i].objectId);
              if(allowedRoles.indexOf(response[i].objectId) !== -1){
                // allowed
                return true;
              }
          }

          // not allowed
          this.router.navigate(['login']);
          return false;

        },
        error => {
          // console.log("Error: " + error);
        }
        );

      return true;
    }

  }
}



// WEBPACK FOOTER //
// /tmp/build_769bc651/src/app/app-routing/role-can-activate-route.guard.ts